import { ShortfallAction } from '../constants/shortfall-action.js';
import { toQuantityDecimal } from '../utils/to-quantity-decimal.js';
/** What a submit does with each short line, shared by the server and the dialog so they cannot disagree. */
export function planShortfall(input) {
    const shortageByKey = new Map(input.shortages.map((shortage) => [shortage.lineKey, shortage]));
    const choiceRequired = [];
    const removedLineQty = [];
    const lineQty = [];
    const backorderLines = [];
    let hasKeep = false;
    let productRemains = false;
    for (const line of input.lines) {
        const found = shortageByKey.get(line.lineKey);
        // WHY: a line with available >= ordered is not short, so any choice on it is dropped (same as a line absent from shortages).
        const shortage = found && found.availableQty.lt(line.qty) ? found : undefined;
        const choice = shortage ? input.choices.get(line.lineKey) : undefined;
        if (!shortage || !choice) {
            if (shortage)
                choiceRequired.push(line.lineKey);
            else if (line.isProductLine && line.qty.gt(0))
                productRemains = true;
            continue;
        }
        // WHY: the rep's numbers are applied, so less stock than they saw is refused; more stock is not.
        // WHY: at the stored scale, so the kept and back-ordered halves persist to exactly the line's quantity.
        const chosenQty = toQuantityDecimal(choice.availableQty);
        if (chosenQty.gt(shortage.availableQty)) {
            choiceRequired.push(line.lineKey);
            continue;
        }
        if (choice.action === ShortfallAction.KEEP) {
            hasKeep = true;
            if (line.isProductLine && line.qty.gt(0))
                productRemains = true;
            continue;
        }
        const planned = { lineKey: line.lineKey, qty: chosenQty.isZero() ? null : chosenQty };
        lineQty.push(planned);
        if (choice.action === ShortfallAction.REMOVE)
            removedLineQty.push(planned);
        else
            backorderLines.push({ lineKey: line.lineKey, qty: line.qty.minus(chosenQty) });
        if (line.isProductLine && chosenQty.gt(0))
            productRemains = true;
    }
    if (choiceRequired.length > 0)
        return { kind: 'choice-required', lineKeys: choiceRequired };
    if (!productRemains && backorderLines.length > 0) {
        // A Back order that would leave nothing to ship is turned into Keep: one back order holding every Back order line in full; removed lines stay removed.
        return {
            kind: 'plan',
            plan: {
                keepsWholeOrder: true,
                convertedToKeep: true,
                lineQty: removedLineQty,
                backorderLines: [],
            },
        };
    }
    if (!productRemains && removedLineQty.length > 0)
        return { kind: 'nothing-to-submit' };
    return {
        kind: 'plan',
        plan: { keepsWholeOrder: hasKeep, convertedToKeep: false, lineQty, backorderLines },
    };
}
//# sourceMappingURL=plan-shortfall.js.map